/* ===========================================================================
 Search
 =========================================================================== */

import Vue from 'vue';
import searchResultCount from './search/searchResultCount.vue';
import searchResult from './search/searchResult.vue';
import pagination from './pagination/pagination.vue';
import {activeClass} from '../settings/settings';

let sellerHeaderVue,
  sellerResultVue,
  paginationVue
;

if (document.getElementById('js-seller-header')) {
  sellerHeaderVue = new Vue({
    el: '#js-seller-header',
    components: {
      searchResultCount,
    },
  });

  sellerResultVue = new Vue({
    el: '#js-seller-results',
    components: {
      searchResult,
    },
  });

  paginationVue = new Vue({
    el: '#js-pagination',
    components: {
      pagination,
    },
  });
} else if (document.getElementById('js-seller-results')) {
  sellerResultVue = new Vue({
    el: '#js-seller-results',
    components: {
      searchResult,
    },
  });
}

export const $sellerResults = document.getElementById('js-seller-results');
const $paginationContainer = document.getElementById('js-pagination');

export class Search {
  reload(page) {
    if (!sellerHeaderVue || this.isLock()) {
      return;
    }

    this.lock();
    sellerResultVue.$refs['js-seller-result'].showLoader();

    let url = $sellerResults.getAttribute('data-url');
    const method = 'GET';
    const header = new Headers({
      'X-Requested-With': 'XMLHttpRequest',
    });

    if (page) {
      url += `/${page}`;
    }

    return fetch(url, {
      method: method,
      headers: header,
      credentials: 'include', // https://developer.mozilla.org/en-US/docs/Web/API/Request/credentials
    }).then(response => {
      this.unLock();
      if (response.ok && response.status === 200) {
        return response.json();
      }
    }).catch(data => {
      this.unLock();
    });
  }

  getLastPage() {
    return parseInt(paginationVue.$refs['js-pagination'].lastPage);
  }

  initPage() {
    this.page = parseInt(paginationVue.$refs['js-pagination'].page);
    return this.page;
  }

  getPage() {
    return this.page || this.initPage();
  }

  getNextPage() {
    return paginationVue.$refs['js-pagination'].nextPage;
  }

  isLock() {
    return paginationVue.$refs['js-pagination'].isLock();
  }

  lock() {
    return paginationVue.$refs['js-pagination'].lock();
  }

  unLock() {
    return paginationVue.$refs['js-pagination'].unLock();
  }

  paginate() {
    this.reload(this.getNextPage())
      .then(data => {
        this.page++;
        // sellerHeaderVue.$refs['js-seller-count'].updateMessage(data.countMessage);
        sellerResultVue.$refs['js-seller-result'].concatResult(data.result);
        paginationVue.$refs['js-pagination'].update(data.page, data.lastPage);
      });
  }
}

// if ($sellerResults) {
//   window.addEventListener('scroll', function (e) {
//     const seller = new Search();
//
//     if (seller.getLastPage() > seller.getPage()) {
//       var d = document.documentElement;
//       var offset = d.scrollTop + window.innerHeight;
//
//       if ($paginationContainer.offsetTop <= offset && seller.isLock() === false) {
//         seller.paginate();
//       }
//     }
//   });
// }

// Open / Close "signal user" link
let sellerSignalUser = $('#js-seller-signal-user'),
  sellerSignalUserMobile = $('#js-seller-signal-user-mobile');

if (sellerSignalUser.length || sellerSignalUserMobile.length) {
  sellerSignalUser.on('click', function (e) {
    e.preventDefault();

    sellerSignalUser.toggleClass(activeClass);
    sellerSignalUser.next('.seller-signal-user-popin').toggleClass(activeClass);
  });

  sellerSignalUserMobile.on('click', function (e) {
    e.preventDefault();

    sellerSignalUserMobile.toggleClass(activeClass);
    sellerSignalUserMobile.next('.seller-signal-user-popin-mobile').toggleClass(activeClass);
  });
}
